<template>
  <div>
    <app-toolbar :crumbs="crumbs" />

    <person-form v-model="model" @cancel="onCancel" @save="onSave" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import appToolbar from '@/components/layout/app-toolbar'
import personApi from '@/services/api/person'
import personForm from './form'

export default {
  components: {
    appToolbar,
    personForm
  },
  data() {
    return {
      crumbs: [
        { text: this.$t('people'), to: { name: 'people-index' } },
        { text: this.$t('edit'), disabled: true }
      ],
      model: {}
    }
  },
  computed: {
    ...mapGetters('messages', ['errors']),
    id() {
      return this.$route.params.personId
    }
  },
  async mounted() {
    this.model = await personApi.fetch(this.id)
  },
  methods: {
    onCancel() {
      this.$router.go(-1)
    },
    async onSave(model) {
      await personApi.put(model.id, model)
      this.$router.push({
        name: 'person-detail',
        params: { personId: model.id }
      })
    }
  }
}
</script>

<style></style>
